import { useState, useEffect } from 'react'

const useWindowWidth = (): number => {
    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 1920,
    )

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>
        const handler = () => {
            clearTimeout(timer)
            timer = setTimeout(() => setWidth(window.innerWidth), 100)
        }
        window.addEventListener('resize', handler)
        return () => {
            clearTimeout(timer)
            window.removeEventListener('resize', handler)
        }
    }, [])

    return width
}

export default useWindowWidth
